module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Take-Test-1484837c563b1fdaaea0e9ba9e1ee64b.svg";